//REACT
import React, { useEffect, useState, useMemo } from 'react';
import Fuse from 'fuse.js';

import SearchFilter from "./SearchFilter";
import SearchTitle from "./SearchTitle"
import SearchBar from "../../Components/SearchBar";

//REDUX
import { useSelector, useDispatch } from "react-redux";
import {Link, useNavigate} from "react-router-dom";


//ANIMATE
import {Animate} from "react-simple-animate";

import SearchResultsGrid from "./SearchResultsGrid";
import SearchSubFilter from "./SearchSubFilter";
import Avatar from "../../Components/Avatar";
import {setLandingIsActive, setSearchTerm, setDashBoardIsActive} from "../../../Features/Misc/activeSlice";
import {setWatchIsActive} from "../../../Features/Misc/navBarSlice";


export default function Search() {
    const dispatch = useDispatch()
    const {watches } = useSelector((state) => state.watches)
    const {learns } = useSelector(state => state.learns)
    const {reads } = useSelector(state => state.reads)
    const { searchTerm, searchFilterType } = useSelector(state => state.active)
    const { searchOrderByNewest, searchOrderByOldest} = useSelector(state => state.active)

    const dataForSearch = useMemo(() => ({
        watches,
        learns,
        reads
    }), [watches, learns, reads]);


    // console.log(dataForSearch)

    //NEW
    const preprocessDataForFuse = (dataForSearch) => {
        return Object.keys(dataForSearch).reduce((preprocessedData, type) => {
            // Map through each item in the type category (watches, learns, reads)
            preprocessedData[type] = dataForSearch[type].map(item => {
                // Extract and concatenate names from _embedded.wp:term[1]
                const namesFromTerms = item._embedded['wp:term'][1]?.map(term => term.name).join(' ') || '';
                // console.log(namesFromTerms)

                // Return a new object with all original item properties plus the extracted names
                return { ...item, extractedNames: namesFromTerms };
            });
            return preprocessedData;
        }, {});
    };

    const processedDataForSearch = preprocessDataForFuse(dataForSearch);
    // console.log(JSON.stringify(datums,null,2) || "DATUMS NOT FOUND")

    //NEW ENDS


    // const searchResults = useMemo(() => {
    //     let results = { watches: [], learns: [], reads: [] };
    //     if (searchTerm) {
    //         ['watches', 'learns', 'reads'].forEach(type => {
    //             const fuse = new Fuse(dataForSearch[type], {
    //                 keys: ['title.rendered', 'content.rendered', ],
    //                 includeScore: true,
    //                 threshold: 0.6,
    //             });
    //             results[type] = fuse.search(searchTerm).map(result => result.item);
    //         });
    //     } else {
    //         results = {
    //             watches: dataForSearch.watches,
    //             learns: dataForSearch.learns,
    //             reads: dataForSearch.reads,
    //         };
    //     }
    //     return results;
    // }, [dataForSearch, searchTerm]);


    //REMOVED  'content.rendered' from the keys below 09/04/24
    const searchResults = useMemo(() => {
        let results = { watches: [], learns: [], reads: [] };
        if (searchTerm) {
            ['watches', 'learns', 'reads'].forEach(type => {
                const fuse = new Fuse(processedDataForSearch[type], {
                    keys: ['title.rendered', 'extractedNames', ],
                    includeScore: true,
                    threshold: 0.3,
                });
                results[type] = fuse.search(searchTerm).map(result => result.item);
            });
        } else {
            results = {
                watches: processedDataForSearch.watches,
                learns: processedDataForSearch.learns,
                reads: processedDataForSearch.reads,
            };
        }
        return results;
    }, [processedDataForSearch, searchTerm]);




    // const items = useMemo(() => {
    //     switch (searchFilterType) {
    //         case 'watches':
    //             return watches;
    //         case 'learns':
    //             return learns;
    //         case 'reads':
    //             return reads;
    //         default:
    //             return [];
    //     }
    // }, [searchFilterType, watches, learns, reads]);
    //
    // const filteredResults = useMemo(() => {
    //     const fuse = new Fuse(items, {
    //         keys: ['title.rendered', 'content.rendered', 'extractedNames'],
    //         includeScore: true,
    //         threshold: 0.6, // Adjust this for more or less strict searching
    //     });
    //
    //     return searchTerm ? fuse.search(searchTerm).map(result => result.item) : items;
    // }, [items, searchTerm]);




    const filteredResults = useMemo(() => {
        // Filter the search results based on the search filter type
        switch (searchFilterType) {
            case 'watches':
                return searchResults.watches;
            case 'learns':
                return searchResults.learns;
            case 'reads':
                return searchResults.reads;
            default:
                // If no specific type is selected, return an empty array
                return [];
        }
    }, [searchResults, searchFilterType]);



    // console.log(filteredResults)

    const numberOfResults = filteredResults.length

    const numberOfResultss = useMemo(() => ({
        total: Object.values(searchResults).reduce((acc, curr) => acc + curr.length, 0),
        watches: searchResults.watches.length,
        learns: searchResults.learns.length,
        reads: searchResults.reads.length,
    }), [searchResults]);
    //
    // console.log(numberOfResultss); // For debugging
    // console.log(numberOfResultss.total)

    const handleExploreEverything = () =>{
        dispatch(setSearchTerm(''));
        dispatch(setWatchIsActive())
        dispatch(setDashBoardIsActive())
    }

    const handleGoToLanding = () =>{
        dispatch(setSearchTerm(''));
        dispatch(setLandingIsActive())
    }


    return (
        <>
            <header className="my-6 lg:my-10">
                <div className="container flex lg:justify-between items-center">

                    <button
                        className="text-white border-2 border-gold-accent rounded-lg aspect-square w-10 mr-3 flex place-content-center place-items-center lg:hidden"

                        onClick={handleExploreEverything}
                    >
                        <i className="ri-arrow-left-line"></i>
                    </button>
                    <button
                        className="text-white border-2 border-white rounded-lg aspect-square w-10 flex place-content-center place-items-center lg:hidden"
                       onClick={handleGoToLanding}
                    >
                        <i className="ri-search-line"></i>
                    </button>

                    <img className="w-32 inline-block ml-auto lg:ml-0" src="https://www.kipmate.com/sortyourkip/client/build/kmlogo.svg"
                         alt="KipMate Logo"/>

                    <div className="hidden lg:flex items-center space-x-6">

                        <SearchBar/>

                        <div>
                            <Avatar width={"w-12"} height={"h-12"} />
                        </div>
                    </div>
                </div>
            </header>

            <div className="container space-y-6 mb-10">
                <SearchTitle searchQuery={searchTerm} />
                <SearchFilter numberOfResults={numberOfResults} numberOfResultss={numberOfResultss}/>
                <SearchSubFilter numberOfResults={numberOfResultss?.total}/>
                <SearchResultsGrid filteredResults={filteredResults} searchFilterType={searchFilterType} />

            </div>
        </>
    );
}
